module.exports = __webpack_public_path__ + "static/media/AMG_Platform_Logo_no_bg.a91a3e4e.svg";